//TODO: DisplayContent for SweepstakeDetails

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';

import './secondChancePromo.scss';

import { SweepstakeDetails, getCMSObject, DrawingGroupTable } from 'sg-ui-components';

const SecondChancePromotion = ({ user, config, cmsSourceFirebase, actions, match, sweep, loading }) => {
    const telescriptSweepstakeDetails = getCMSObject('data.components.teleScripts.sweepstakeDetails.jsonBlock');
    const telescriptDrawingGroupTable = getCMSObject('data.components.teleScripts.drawingGroupTable.jsonBlock');
    const [promotionName, setPromotionName] = useState('Promotion Details');
    const winnerAutoCertified = config?.web?.features?.winnerAutoCertified;

    const DrawingGroupTableWrapper = ({ drawingGroup, loggedIn }) => {
        /*
            When the jurisdiction is unable to legally disclose the winners, an information modal should be displayed at the end of the drawing. 
            Since no winning file will be uploaded to the system for the drawing, we need to automatically certify the drawings. Otherwise,
            the winner link for the modal will not be displayed at all.
        */
        if (winnerAutoCertified) {
            const todayTimestamp = new Date().getTime();
            const updatedDrawingGroup = {
                ...drawingGroup,
                drawings: drawingGroup.drawings.map((item) => (item.quantum_end < todayTimestamp ? { ...item, certified: true } : item)),
            };

            return (
                <DrawingGroupTable
                    drawingGroup={updatedDrawingGroup}
                    loggedIn={loggedIn}
                    telescript={telescriptDrawingGroupTable}
                    WinnerLink={WinnerLinkWrapper}
                />
            );
        }

        return <DrawingGroupTable drawingGroup={drawingGroup} loggedIn={loggedIn} telescript={telescriptDrawingGroupTable} WinnerLink={WinnerLinkWrapper} />;
    };

    return (
        <Layout
            {...{
                user,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName ?? '',
                    },
                ],
            }}>
            <SweepstakeDetails
                {...{ user, sweep: sweep.sweepDetails, actions, loading }}
                telescript={telescriptSweepstakeDetails}
                DrawingGroupTable={DrawingGroupTableWrapper}
                setPageTitle={setPromotionName}
            />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondChancePromotion);
